import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import data from "@/data/projects/projects.json";
import PageMeta from "@/components/common/PageMeta";
import Loading from "@/components/common/Loading";
import ProjectsHorizontal from "@/components/portfoliu/projects-horizontal/ProjectsHorizontal";
import Filters from "@/components/portfoliu/filters/Filters";
import Intro from "@/components/service/components/intro/Intro";
// import { ProjectData } from "@/pages/Project";

// type ProjectPreview = Pick<
//   ProjectData,
//   "id" | "title" | "imgUrl" | "details" | "list" | "date" | "tags" | "type"
// >;

const WebsiteuriDePrezentare = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    setLoading(false);
  }, []);

  // Filter website projects
  const websiteProjects = data.filter(project => project.type === "websituri");

  // Portfolio intro data
  const portfolioIntroData = {
    tag: "Portfoliu",
    title: "Website-uri de Prezentare",
    text: "Soluții complete de prezentare online",
    description: "Descoperă website-urile de prezentare pe care le-am dezvoltat pentru clienții noștri, combinând designul modern cu funcționalitatea optimă."
  };

  if (loading) return <Loading />;

  return (
    <>
      <PageMeta title="Website-uri de Prezentare | Pixado" description="Proiecte complete de website-uri de prezentare dezvoltate de Pixado" />
      <Intro data={portfolioIntroData} />
      <Container style={{ marginTop: "-40px", textAlign: "center" }}>
        <div style={{ 
          display: "inline-block", 
          fontSize: "0.7em",
          transform: "scale(0.85)"
        }}>
          <Filters projects={data} setProjects={() => {}} />
        </div>
      </Container>
      <Container style={{ height: "100%" }}>
        <ProjectsHorizontal projects={websiteProjects} />
      </Container>
    </>
  );
};

export default WebsiteuriDePrezentare;